import { C, SANS } from "./theme";

const LOGO_DARK = "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/4e392029e_TruestaysLogoDark.png";
const LOGO_LIGHT = "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/24682ceeb_TruestaysLogo.png";

export function LogoDark({ height = 18 }) {
  return <img src={LOGO_DARK} alt="Truestays" style={{ height, width: "auto", display: "block" }} crossOrigin="anonymous" />;
}

export function LogoLight({ height = 24 }) {
  return <img src={LOGO_LIGHT} alt="Truestays" style={{ height, width: "auto", display: "block" }} crossOrigin="anonymous" />;
}

export function ReportHeader({ host, address, cityName }) {
  return (
    <div style={{ height: 70, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 64px", flex: "none" }}>
      <LogoDark />
      <div style={{ fontFamily: SANS, fontSize: 9.5, color: C.faint, textAlign: "right", lineHeight: 1.5 }}>
        {host} · {address}, {cityName}
      </div>
    </div>
  );
}

export function ReportFooter({ page, total = 6 }) {
  return (
    <div style={{ marginTop: "auto", height: 50, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 64px", fontFamily: SANS, fontSize: 9, color: C.faint, flex: "none" }}>
      <span>truestays.co.uk</span>
      <span>{page} / {total}</span>
    </div>
  );
}

export function Eyebrow({ children, color }) {
  return (
    <div style={{ fontFamily: SANS, fontSize: 9.5, fontWeight: 600, letterSpacing: "0.14em", textTransform: "uppercase", color: color || C.copper }}>
      {children}
    </div>
  );
}

export function Label({ children, color }) {
  return (
    <div style={{ fontFamily: SANS, fontSize: 9.5, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: color || C.faint }}>
      {children}
    </div>
  );
}